import { render } from "./settingsCloud.vue?vue&type=template&id=655b645f&scoped=true&ts=true"
import script from "./settingsCloud.vue?vue&type=script&lang=ts"
export * from "./settingsCloud.vue?vue&type=script&lang=ts"

import "./settingsCloud.vue?vue&type=style&index=0&id=655b645f&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655b645f"]])

export default __exports__